import { Info } from "lucide-react";
import type * as React from "react";

/**
 * Nota esplicativa sotto il titolo di ogni pagina admin. Icona fissa (``Info``):
 * la voce di sezione è già identificata dalla rail e dal titolo, ripeterla qui
 * non aggiungeva informazione.
 *
 * Pastiglia arancione satinata — stesso oggetto delle voci di calendario e del
 * badge in OrgSwitcher: `rounded-full` + `bg-ando-orange-soft`. Il token va
 * usato NUDO: `/NN` su un rgba() ne SOSTITUISCE l'alpha (DESIGN.md §2), quindi
 * `orange-soft/40` non è più tenue, è arancione al 40%. Il glifo è
 * `ando-orange` pieno. Sul velo pesca sta a ~2,2:1, ma la soglia 3:1 di WCAG
 * 1.4.11 NON si applica: vale per gli elementi grafici NECESSARI a capire il
 * contenuto, e questa icona è ridondante con il testo accanto (per questo è
 * anche `aria-hidden`).
 */
export function AdminPageHint({ children }: { children: React.ReactNode }): React.ReactElement {
  return (
    <div className="mt-1.5 flex items-start gap-2 text-xs leading-relaxed">
      <span
        aria-hidden
        className="mt-px inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ando-orange-soft text-ando-orange"
      >
        <Info size={12} strokeWidth={2} />
      </span>
      <span>{children}</span>
    </div>
  );
}
